import React from 'react';

import {
    PushNotificationRemoveEventFamily,
} from 'src/components/remove-event-family/push-notification-remove-event-family';

import {Icons, Sizes} from '@pb/kit-component-icon';
import {BasicIconButton} from '@pb/kit-component-icon-button';
import {usePushNotification} from '@pb/kit-component-push-notification';

import {removeEventFamily} from './remove-event-family.module.styl';

type Props = {
    name: string,
    onError: (message?: string) => void,
};

export const RemoveEventFamily = ({name, onError}: Props) => {
    const {onCreateNote, onCloseNote} = usePushNotification();

    const onRemove = () => {
        onCreateNote({
            id: `${name}`,
            body: () => (
                <PushNotificationRemoveEventFamily
                    name={name}
                    onClose={onCloseNote}
                    onError={onError}
                />
            ),
            buttonProps: {icon: Icons.CLOSE},
            autoHideTimeout: 10000,
        });
    };

    return (
        <BasicIconButton
            className={removeEventFamily}
            iconProps={{type: Icons.TRASH_LIGHT, size: Sizes.Size_14}}
            onClick={onRemove}
        />
    );
};
